import { Typography } from "@p0security/ui";

const { Paragraph } = Typography;

/** What to have ready before adding a site, shown above the new site's form
 * before the customer has entered anything. A copy of Jira (HI)'s, for the
 * tracker. */
export const NewPreamble: React.FC = () => (
  <>
    <Paragraph>
      P0 files findings as issues on a Jira Cloud site, acting in Jira as an
      Atlassian service account, with an OAuth credential whose client secret P0
      stores encrypted.
    </Paragraph>
    <Paragraph>
      Have ready an admin of the Atlassian organization that owns the site, to
      create the service account and its credential, and a Jira admin to give it
      permissions on the project P0 files findings in.
    </Paragraph>
    <Paragraph>
      Below, enter the site&apos;s host. The next page lists the steps: create
      the service account, give it Jira access and the tracker&apos;s
      permissions, and create its credential.
    </Paragraph>
  </>
);
